
export async function simpleForm(title: string, numlines:number, label: string, value: string, placeholder: string = '' ): Promise<string> {

    return new Promise((resolve, reject) => {
        const form = document.createElement('form');
        form.id = title;
        form.enctype = 'multipart/_form-data';

        form.innerHTML = `
            <h2>${title}</h2>
            
            <label for="sf-value">${label}</label>
            <textarea id="sf-value" type="text" rows="${numlines} placeholder="${placeholder}">${value}</textarea>

            <div class="buttons">
                <button id="sf-ok">OK</button>
                <button id="sf-abort">Avbryt</button>
            </div>
        `;
        document.body.appendChild(form);

        const btnOk = form.querySelector('#sf-ok') as HTMLButtonElement;
        btnOk?.addEventListener('click', (e: Event) => {
            e.preventDefault();
            const textvalue = (form.querySelector('#sf-value') as HTMLTextAreaElement).value;
            form.remove();
            resolve(textvalue);
        });

        const btnAbort = form.querySelector('#sf-abort') as HTMLButtonElement;
        btnAbort?.addEventListener('click', (e: Event) => {
            e.preventDefault();
            form.remove();
            reject();
        });

        const inp = form.querySelector('#sf-value') as HTMLInputElement;
        inp.focus();
    });
}

